import { css, Theme } from '@emotion/react'
import HeroAdvertising from '../molecules/HeroAdverising'
import HeroCreative from '../molecules/HeroCreative'

type Props = {
  route: string
}

const ServiceHero: React.FC<Props> = ({ route }) => {
  return (
    <div css={styles.wrapper}>
      {route == 'advertising' ? <HeroAdvertising /> : <HeroCreative />}
    </div>
  )
}

const styles = {
  wrapper: css`
    position: relative;
    overflow: hidden;
    width: 100vw;
    height: 90vh;
    min-height: 600px;
    @media (min-width: 960px) {
      min-height: 1000px;
    }
  `,
  container: (theme: Theme) => css`
    position: relative;
    background-color: ${theme.palette.secondary.main};
    overflow: hidden;
    height: 100%;
    width: 100%;
  `,
  image: css`
    position: absolute;
    top: 60%;
    right: 0;
    height: 100%;
    width: 100vw;
    @media (min-width: 1200px) {
      top: 15%;
      width: 850px;
    }
  `,
  content: css`
    position: absolute;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    width: 90vw;
    max-width: 1080px;
    top: 17%;
    left: 5%;
    @media (min-width: 960px) {
      justify-content: start;
      align-items: flex-start;
      width: 80vw;
    }
    @media (min-width: 1200px) {
      width: 70%;
      top: 25%;
      left: calc(15% - (500px - 25vw));
    }
  `,
  copy: (theme: Theme) => css`
    font-style: normal;
    font-weight: 900;
    text-align: center;
    line-height: 3rem;
    font-size: 6vw;
    & span {
      color: #2ea595;
    }
    @media (min-width: 960px) {
      text-align: start;
      line-height: 6rem;
      font-size: 4rem;
    }
  `,
  points: css`
    width: 80vw;
    @media (min-width: 960px) {
      width: 600px;
    }
  `,
  btn_container: css`
    width: 600px;
  `,
  authority: css`
    position: absolute;
    bottom: 0;
    right: 5%;
    width: 40%;
    height: auto;
    @media (min-width: 960px) {
      width: 500px;
    }
  `,
}

export default ServiceHero
